import { ecboClient, getHeaderLocale } from 'lib/axios'

import type { LegacyCoinLockersResponse } from 'features/coin-locker/types/legacyCoinLocker'

const API_LEGACY_COIN_LOCKERS = '/api/web/coin_lockers'

export type FetchLegacyCoinLockersParams = {
  latitude: number | string
  longitude: number | string
  locale: string
}

export const fetchLegacyCoinLockersApi = async (params: FetchLegacyCoinLockersParams) => {
  const response = await ecboClient.get<LegacyCoinLockersResponse>(API_LEGACY_COIN_LOCKERS, {
    params: {
      latitude: params.latitude,
      longitude: params.longitude,
    },
    headers: { 'Accept-Language': getHeaderLocale(params.locale) },
  })

  return response.data
}
